/**
 * Collection Grid: Result Count Observer
 * Watches Globo filter checkbox clicks and updates the visible
 * result count badge. Also syncs the UI filter button states.
 *
 * Extracted from main-collection-product-grid.liquid (pure JS, no Liquid)
 */

/* --- Click handler: update result count when filters change --- */
document.addEventListener('click', function (e) {
  const elem = document.querySelector('.collection-result-count');
  const btn = e.target.closest("button[role='checkbox']");
  if (btn && !btn.classList.contains('checked')) {
    const intervalId = setInterval(() => {
      const updatedSummary = document.querySelector('.gf-summary b');
      if (updatedSummary && resultCount) {
        const number = updatedSummary.textContent.trim();
        if (resultCount.innerHTML === number) {
          clearInterval(intervalId);
        } else {
          resultCount.innerHTML = number;
        }
      }
    }, 1000);
    if (elem) {
      elem.style.visibility = 'visible';
      elem.style.opacity = '1';
    }
  } else if (btn) {
    const gfValue = btn.getAttribute('data-fvalue')?.trim();
    if (gfValue) {
      const uiBtn = document.querySelector(`.js-content-filter[data-filter-values="${gfValue}"]`);
      if (uiBtn && uiBtn.hasAttribute('data-state')) {
        uiBtn.removeAttribute('data-state');
      }
    }
  }

  if (btn && btn.classList.contains('checked')) {
    const elem = document.querySelector('.gf-actions .globo-selected-items-wrapper .globo-selected-items');
    if (elem) {
      const liCount = elem.querySelectorAll('li').length - 1;
      if (liCount < 1) {
        const elem = document.querySelector('.collection-result-count');
        elem.style.visibility = 'hidden';
        elem.style.opacity = '0';
      }
      const intervalId = setInterval(() => {
        const updatedSummary = document.querySelector('.gf-summary b');
        if (updatedSummary && resultCount) {
          const number = updatedSummary.textContent.trim();
          if (resultCount.innerHTML === number) {
            clearInterval(intervalId);
          } else {
            resultCount.innerHTML = number;
          }
        }
      }, 1000);
    }
  }
  const removeLink = e.target.closest("a[onclick^='removeFilterValue']");
  if (removeLink) {
    const closestUl = e.target.closest('ul');
    if (closestUl?.classList?.contains('globo-selected-items')) {
      const liCount = closestUl.querySelectorAll('li').length - 2;
      const intervalId = setInterval(() => {
        const updatedSummary = document.querySelector('.gf-summary b');
        if (updatedSummary && resultCount) {
          const number = updatedSummary.textContent.trim();
          if (resultCount.innerHTML === number) {
            clearInterval(intervalId);
          } else {
            resultCount.innerHTML = number;
          }
        }
      }, 1000);
      if (liCount < 1 && elem) {
        elem.style.visibility = 'hidden';
        elem.style.opacity = '0';
      }
    }
  }
});

/* --- On page load: show result count if filters are already active --- */
document.addEventListener('DOMContentLoaded', () => {
  const checkExist = setInterval(() => {
    const elem = document.querySelector('.gf-actions .globo-selected-items-wrapper .globo-selected-items');
    if (elem) {
      const liCount = elem.querySelectorAll('li').length;
      if (liCount > 0) {
        const ele = document.querySelector('.collection-result-count');
        if (ele) {
          clearInterval(checkExist);
          ele.style.visibility = 'visible';
          ele.style.opacity = '1';
        }
        const updatedSummary = document.querySelector('.gf-summary b');
        if (updatedSummary && resultCount) {
          const number = updatedSummary.textContent.trim();
          resultCount.innerHTML = number;
        }
      }
    }
  }, 1000);
});
